import { Form, Select, Tag, Tooltip } from "antd"
import { NamePath } from "antd/lib/form/interface"
import { FC } from "react"
import { COUNTRY_CODES } from "utils/countryCodes"

interface GeoPickerElementProps {
    label?: string;
    name: NamePath;
    initialValue?: string[];
    style?: React.CSSProperties;
    disabled?: boolean;
    onChange?: (value: string[]) => void;
    withGlobal?: boolean;
}

const GeoPickerElement: FC<GeoPickerElementProps> = ({ label, name, initialValue, style, disabled, onChange, withGlobal }) => {
  const form = Form.useFormInstance()
  const selectedValues: string[] = Form.useWatch(name, form) || initialValue || []

  const countryCodes = withGlobal ? [...COUNTRY_CODES, { code: "global", name: "Global" }] : COUNTRY_CODES

  const isGlobalSelected = selectedValues.includes("global")

  const options = countryCodes.map(({ code, name }) => ({
    label: `${name} (${code})`,
    value: code,
    disabled: isGlobalSelected && code !== "global",
  }))

  return (
    <Form.Item label={label} name={name} initialValue={initialValue} style={{ width: "100%" }}>
      <Select
        mode="tags"
        disabled={disabled}
        allowClear
        style={{ width: "100%", ...style }}
        onChange={(value: string[]) => {
          let finalValue = value
          if (value.includes("global")) {
            finalValue = ["global"]
          }
          form?.setFieldValue?.(name, finalValue)
          onChange?.(finalValue)
        }}
        placeholder="No countries selected"
        options={options}
        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
        tagRender={({ closable, value, label, onClose }) => {
          const handleMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
            event.preventDefault()
            event.stopPropagation()
          }

          return (
            <Tooltip title={label}>
              <Tag
                onMouseDown={handleMouseDown}
                closable={closable}
                onClose={onClose}
                style={{ marginRight: 3, cursor: "default" }}
              >
                {value}
              </Tag>
            </Tooltip>
          )
        }}
      />
    </Form.Item>
  )
}

export default GeoPickerElement
